// extracted by mini-css-extract-plugin
export var container = "_4g-0";
export var fallback = "_4g-5";
export var fallbackIcon = "_4g-6";
export var hidden = "_4g-2";
export var image = "_4g-3";
export var loaded = "_4g-4";
export var placeholder = "_4g-1";